// extracted by mini-css-extract-plugin
export default {"conversationNotice":"_5V58vP5Lhsp3n4VxMYMQ82"};